module.exports = __webpack_public_path__ + "static/media/inbox-in.86060bcb.svg";